
import { FETCH_ALL, ADD_NEW_INVENTORY, UPDATE_INVENTORY, DELETE_INVENTORY, GET_INVENTORY, START_LOADING, END_LOADING, FETCH_INVENTORY_BY_USER } from '../actions/constants'

const inventories = (state = { isLoading: true, inventories: [] }, action) => {
    switch (action.type) {
      case START_LOADING:
        return { ...state, isLoading: true };
      case END_LOADING:
        return { ...state, isLoading: false };
      case FETCH_ALL:
        return {
          ...state,
          inventories: action.payload.data,
          currentPage: action.payload.currentPage,
          numberOfPages: action.payload.numberOfPages,
        };
      case FETCH_INVENTORY_BY_USER:
        return { ...state, inventories: action.payload };

      case GET_INVENTORY:
        return { ...state, inventory: action.payload };
      case ADD_NEW_INVENTORY:
        return { ...state, inventories: [...state.inventories, action.payload] };
      case UPDATE_INVENTORY:
        return { ...state, inventories: state.inventories.map((inventory) => (inventory.id === action.payload.id ? action.payload : inventory)) };
      case DELETE_INVENTORY:
        return { ...state, inventories: state.inventories.filter((inventory) => inventory.id !== action.payload) };
      default:
        return state;
    }
  };

  export default inventories



//   const inventories =( state = { inventories: [], }, action ) => {
//     switch (action.type) {
//         case FETCH_ALL:
//             return { ...state, inventories: action.payload }

//         case GET_INVENTORY:
//             return { ...state, inventory: action.payload }

//         case ADD_NEW:
//             return { ...state, inventories: [...state.inventories, action.payload] }

//         case UPDATE:
//             return { ...state, inventories: state.inventories.map((inventory) => inventory._id === action.payload ? action.payload : inventory) }
        
//         case DELETE: 
//         return {...state, inventories: state.inventories.filter((inventory) => inventory._id !== action.payload)}
        
//         default:
//             return state;
//     }
// }

// export default inventories
